/* Three images masonry */
import 'slick-carousel';

export function three_images_masonry() {

	( ( $ ) => {

		const init = () => {

			if ( $( '.block--three-images-masonry' ).length <= 0 ) {
				return;
			}

			$( '.block--three-images-masonry--images' ).each( ( i, e ) => {
				const wrapper = $( e );
				const slider = wrapper.find( '.mobile-slider' );
				
				slider.slick( {
					arrows: true,
					infinite: false,
					slidesToShow: 1,
					dots: true,
					slidesToScroll: 1,
					draggable: false,
					fade: true,
					rows: 0,
					responsive: [
						{
							breakpoint: 992,
							settings: {
								draggable: true,
								fade: true,
								adaptiveHeight: true,
							}
						}
					]
				} );
			});
		}

		init();

	} )( window.jQuery );
}
